import { getCountryByCode } from "../../../../utils/Helper";
import { capitalize } from "../../../../global_functions/global";

/* Reading one tracked business. */

/* Transcribed: state and country when there is a state worth printing, country
   alone otherwise. "-" is the API's placeholder for "no state", and the live
   code checks for it explicitly. */
export const trackedAddress = (row) => {
  const country = capitalize(getCountryByCode(row?.country));
  if (row?.state && row.state !== "-") {
    return `${capitalize(row.state)}, ${country}`;
  }
  return country;
};

/* Transcribed: the count of `updates`, worded, and whether it is actionable.
   Only a row with updates navigates anywhere. */
export const trackedChanges = (row) => {
  const count = row?.updates?.length || 0;
  return {
    count,
    /* Sentence case rather than the live screen's Title Case, which is the
       design's treatment. The count and the threshold are unchanged. */
    label: count > 0 ? `${count} new update${count === 1 ? "" : "s"}` : "No new updates",
    actionable: count > 0,
  };
};

/* Transcribed: a row is openable when it has a TREVEX company id or a WorldBox
   id, and the id is what /search/:id is keyed by. */
export const trackedProfileId = (row) => row?.company_id || row?.worldbox_id || null;

/* Transcribed precedence, exactly: an outstanding WorldBox order outranks the profile's own status, then verified, then claimed. */
export const trackedStatus = (row) => {
  if (row?.status === "WORLDBOX_ORDER_CREATED") return "in_progress";
  if (row?.verified) return "verified";
  if (row?.claimed) return "claimed";
  return "listed";
};

/* The completion bar's colour band. */
export const COMPLETION_BANDS = { low: 50, high: 85 };

export const completionTone = (percent) => {
  const value = Number(percent) || 0;
  if (value < COMPLETION_BANDS.low) return "low";
  if (value < COMPLETION_BANDS.high) return "mid";
  return "high";
};

/* Clamped: the bar is a width, and a percent outside 0–100 would either
   vanish or overflow its track. The printed figure stays as the API sent it. */
export const completionWidth = (percent) => {
  const value = Number(percent);
  if (Number.isNaN(value)) return 0;
  return Math.max(0, Math.min(100, value));
};
